import React, { useContext, useEffect, useState } from 'react'
import ButtonBlackReturn from '../Buttons/ButtonBlackReturn'
import { t } from 'i18next'
import ErrorScreen from '../MessagesScreens/ErrorScreen'
import { ButtonBlue } from '../Buttons/ButtonBlue'
import { Spinner } from 'reactstrap'
import ItemSelectableWithCheck from '../ItemSelectable/ItemSelectableWithCheck'
import useWindowSize from '../../customHooks/useWindowSize'
import AccessContext from '../../context/AccessContext/AccessContext'
import { getTenantInfoByKey, getUserBuilding, getUserOpening } from '../../helpers/helpers'
import AccessPersonToVisitContext from '../../context/AccessPersonToVisitContext/AccessPersonToVisitContext'
import CustomPagination from '../CustomPagination/CustomPagination'
import { EmptyStateOne } from '../Empty/EmptyStateOne'

const SelectPersonToVisit = () => {

    const { windowWidth } = useWindowSize();

    const { accessState, setStep } = useContext(AccessContext);
    const { accessWithCar, accessWithEquipmentOrTools, type, employee, visit } = accessState;

    const { setAccessPersonsToVisitSelected, getAccessPersonsToVisit, accessPersonToVisitState } = useContext(AccessPersonToVisitContext);
    const { isFetching, error, message, accessPersonsToVisitSelected, accessPersonsToVisit, totalPages } = accessPersonToVisitState;

    const [personsSelected, setPersonsSelected] = useState(accessPersonsToVisitSelected);

    const isVisit = 'ACCESS_VISIT' === type;

    const initialStateFilter = {
        opening: (getUserOpening().codigo || null),
        building: (getUserBuilding().buildingId || null),
        searchText: '',
        resourceType: isVisit ? 'VIS' : 'EMP',
        resourceId: isVisit ? visit.document : String(employee.id),
        regFrom: 1,
        pageLength: 10,
    }

    const [filter, setFilter] = useState(initialStateFilter);
    const { searchText, regFrom } = filter;

    const [wasFetch, setWasFetch] = useState(false);

    const [searchTextState, setSearchTextState] = useState(searchText);

    const maximumPeopleToVisit = getTenantInfoByKey('maximum_people_to_visit');

    const mandatoryPeopleToVisit = getTenantInfoByKey('mandatory_people_to_visit');

    const disabled = () => {
        if (mandatoryPeopleToVisit === true) {
            return personsSelected.length === 0 || personsSelected.length > maximumPeopleToVisit
        }
        return false
    }

    const isAdded = (id) => {
        const isAlReadyAdded = personsSelected.some((personSelected) => personSelected.peopleToVisitId === id);
        return isAlReadyAdded;
    };

    const handleSelectPerson = (e, newPerson) => {
        const { checked } = e.target;
        if (checked) {
            setPersonsSelected([...personsSelected, newPerson])
        } else {
            setPersonsSelected(personsSelected.filter((personSelected) => personSelected.peopleToVisitId !== newPerson.peopleToVisitId))
        }
    };

    const setPage = (newPage) => {
        setFilter({
            ...filter,
            regFrom: newPage
        })
    }

    const search = (e) => {
        if (e.key === 'Enter') {
            setFilter({
                ...filter,
                searchText: searchTextState,
                regFrom: 1
            })
        }
    };

    const handleNextStep = () => {
        if (disabled()) return
        setAccessPersonsToVisitSelected(personsSelected);
        setStep('DETAIL');
        return
    };

    const handleReturnStep = () => {
        const haveAccessBuildings = getUserBuilding().buildingDescription !== t('NO_BUILDING');;

        if (haveAccessBuildings) {
            setStep('SELECT_AREA');
            return
        }

        if (accessWithEquipmentOrTools) {
            setStep('SELECT_EQUIPMENT_OR_TOOLS');
            return
        }

        if (accessWithCar) {
            const prevStep = isVisit ? 'VISIT_VEHICLE_FORM' : 'VEHICLES_SELECTABLE';
            setStep(prevStep);
            return
        }

        setStep('ACCESS_WITH');
        return

    };

    const handleGetPersons = () => {
        getAccessPersonsToVisit(filter);
        setWasFetch(true);
    }

    useEffect(() => {
        handleGetPersons();
        // eslint-disable-next-line
    }, [searchText, regFrom])

    useEffect(() => {
        if (wasFetch === true && error === false && accessPersonsToVisit.length === 0 && mandatoryPeopleToVisit === false) {
            handleNextStep()
        }
        // eslint-disable-next-line
    }, [isFetching])


    return (
        <div className='d-flex flex-column justify-content-between h-100'>

            <div>
                <div>
                    <h5 className='d-sm-block d-none fw-bold mb-4'>{t('SELECT_PERSON_TO_VISIT')}</h5>
                    <input
                        type="text"
                        className="form-control"
                        placeholder={t('SEARCH')}
                        name='search_text'
                        value={searchTextState}
                        onKeyPress={search}
                        onChange={(e) => setSearchTextState(e.target.value)}
                    />
                </div>

                {isFetching && (
                    <div className='d-flex justify-content-center mt-5'>
                        <Spinner />
                    </div>
                )}

                <div className='mt-4'>
                    <h6 className='fw-bold'>
                        {t('SELECTED')}:  {personsSelected.length} / {maximumPeopleToVisit}
                    </h6>
                </div>

                {(!isFetching && !error && accessPersonsToVisit.length === 0) && (
                    <EmptyStateOne
                        message={t('NO_DATA')}
                    />
                )}

                {error && (<ErrorScreen title={'Error'} description={message} />)}

                {(!isFetching && !error) && (
                    <div
                        className='d-flex flex-column gap-2 no-show-scroll mt-3'
                        style={{ maxHeight: windowWidth <= 576 ? '370px' : '450px', overflowX: 'auto' }}
                    >
                        {accessPersonsToVisit.map((personToVisit) =>
                            <ItemSelectableWithCheck
                                key={personToVisit.peopleToVisitId}
                                onChange={(e) => handleSelectPerson(e, personToVisit)}
                                checked={isAdded(personToVisit.peopleToVisitId)}
                            >
                                <div className='d-flex align-items-center gap-3'>
                                    <div>
                                        <h5 className='blue-dark-text-two'>
                                            {personToVisit.documentNumber}
                                        </h5>
                                    </div>
                                    <div>
                                        <h5 className='blue-text mb-0'>
                                            {personToVisit.name} {personToVisit.lastName}
                                        </h5>
                                        <span className='subtitle'>
                                            {personToVisit.sector ? personToVisit.sector.sectorName : t('WITHOUT_SECTOR')}
                                        </span>
                                    </div>
                                </div>
                            </ItemSelectableWithCheck>
                        )}
                    </div>
                )}
            </div>
            <div className='d-flex flex-column gap-3 mt-4 mb-4'>
                <div className='d-flex justify-content-center'>
                    <CustomPagination
                        setPage={setPage}
                        totalPages={totalPages}
                        page={regFrom}
                        disabled={isFetching}
                    />
                </div>
                <div className='d-flex justify-content-between align-items-center'>
                    <div className="w-75">
                        <ButtonBlackReturn
                            title={t('GET_BACK')}
                            onClick={handleReturnStep}
                        />
                    </div>
                    <div className="w-50">
                        <ButtonBlue
                            className='w-100'
                            disabled={disabled()}
                            onClick={handleNextStep}
                        >
                            {t('NEXT')}
                        </ButtonBlue>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default SelectPersonToVisit